import type { SalesLeadModalConfig } from '@ltvco/refresh-lib/v2';

export const SALES_LEAD_MODAL_CONFIG: SalesLeadModalConfig = {
  copy: {
    api: {
      title: 'Request API Information',
      subtitle:
        'Contact us to learn more about the BeenVerified API and our team will be in touch shortly.',
      emailPlaceholder: 'BUSINESS EMAIL',
      estimatedLabel: 'Estimated API Requests Per Month',
      useCasesLabel: 'How do you plan to use the BeenVerified API?',
      useCasePlaceholder:
        "e.g. We're a licensed collections agency and need current phone numbers and mailing addresses to reach account holders on past-due accounts. We'd pull contact info for roughly 2,500–3,000 individuals per month, scaling to about 5,000 during peak quarters.",
      ga4Type: 'b2b_api_contact_form',
      useCasePrefix: 'API',
    },
    upgrade: {
      title: 'Need a custom plan?',
      subtitle:
        'Tell us about your needs and our team will be in touch shortly.',
      emailPlaceholder: 'EMAIL',
      estimatedLabel: 'Estimated Monthly Searches',
      useCasesLabel: 'How do you plan to use BeenVerified?',
      useCasePlaceholder:
        "e.g. We're a licensed collections agency and need current phone numbers and mailing addresses to reach account holders on past-due accounts. We currently run reports on about 1,500 individuals per month but need to scale to roughly 4,000 to keep up with new accounts.",
      ga4Type: 'b2b_upgrade_contact_form',
      useCasePrefix: null,
    },
  },
  hubSpot: {
    submitUrl:
      'https://api.hsforms.com/submissions/v3/integration/submit/51330519/568e5f97-b1e9-4739-a4e8-cbd75a6c232f',
    objectTypeId: '0-1',
    brandTag: { name: 'ltv_brand_new', value: 'been_verified' },
  },
  aiVetting: { enabled: true, brand: 'been_verified' },
};
